import { ProvinceType } from './model';

export const TRACK_SPLITOR = '__';

export const INDICATOR_DIMEN_CHANGE_PERIOD = '2025_Q3'; // 维度变更周期，不再使用梯队对比

export const GROWUP_LISTENERS = {
  CHECK_ABILITY_DETAIL: 'GROWUP_CHECK_ABILITY_DETAIL',
  CHECK_ABILITY_DETAIL_PAGE: 'GROWUP_CHECK_ABILITY_DETAIL_PAGE',
  CHECK_SUGGESTIONS_LIST_GROUP: 'GROWUP_CHECK_SUGGESTIONS_LIST_GROUP',
  CHECK_SUGGESTIONS_DETAIL: 'GROWUP_CHECK_SUGGESTIONS_DETAIL',
  SWITCH_AGENCY_RANGE: 'GROWUP_SWITCH_AGENCY_RANGE',
  SWITCH_CUSTOM_TYPE: 'GROWUP_SWITCH_CUSTOM_TYPE',
};

export const PROVINCE_TYPE_MAP: any = {
  [ProvinceType.s]: 'S级省区',
  [ProvinceType.a]: 'A级省区',
  [ProvinceType.b]: 'B级省区',
};

export const REPORT_EVENT = {
  summaryPage: {
    action: 'growup-page-summary',
  },
  detailPage: {
    action: 'growup-page-detail',
  },
  incentiveSummaryPage: {
    action: 'growup-page-incentive-summary',
  },
  incentiveDetailActivePage: {
    action: 'growup-page-incentive-detail-active',
  },
  incentiveDetailHistoryPage: {
    action: 'growup-page-incentive-detail-history',
  },
};
